import { getUriParams } from '../../../helpers';
import {
  CORE, RELATORIOS, gateway,
} from '../../api';

export default {
  buscarInfoValidarProcesso(pageable, order) {
    const sortedQuery = order.reduce((obj, sort) => `${obj}&sort=${sort}`, '');
    const queryParam = getUriParams(pageable);

    return gateway.get(`${CORE}/validar-processos/buscar-processos?${queryParam}${sortedQuery}`);
  },

  buscarIdsProcessos() {
    return gateway.get(`${CORE}/validar-processos/ids-processos`);
  },

  exportarValidacaoProcessos() {
    return gateway.post(`${RELATORIOS}/validar-processos/exportar-validacao-processos`, { responseType: 'blob' });
  },

  proximaFaseProcesso(listIds) {
    return gateway.post(`${CORE}/validar-processos/proxima-fase`, listIds);
  },
};
